module.exports = __webpack_public_path__ + "img/hellow-yellow.d1c7fcc2.png";